export default __webpack_public_path__ + "static/marketplace@2x-16a041ab718f0780b81431a985317058.png";